import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={19.175}
    height={26.223}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14714 20123"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0,.str1{stroke:#2b2a29;stroke-width:580.06}.str0{stroke-width:221.003}.fil0,.fil1,.fil2{fill:none;fill-rule:nonzero}.fil0,.fil2{fill:#2b2a29}.fil2{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541119472">
        <path d="M4256 8410h559V1254h-559z" className="fil0" />
        <path
          d="M8728 18962h69c92-417 141-909 141-1491 0-3653-1936-9067-4324-9067S290 13818 290 17471c0 582 49 1074 142 1491h69"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 580.06,
          }}
        />
        <path d="M11389 3535h368V111h-368z" className="fil0" />
        <path
          d="M14283 10707h48c61-275 93-599 93-983 0-2408-1276-5978-2851-5978S8722 7316 8722 9724c0 384 32 708 93 983h53"
          className="fil1-bg stroke1"
          style={{
            strokeWidth: 580.06,
          }}
        />
        <path
          d="M4672 18091c2342 0 4240 390 4240 871s-1898 871-4240 871-4240-390-4240-871 1898-871 4240-871zM11550 10165c1560 0 2825 267 2825 596s-1265 596-2825 596-2825-267-2825-596 1265-596 2825-596z"
          className="fil2 fill"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
